var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_vm._v("\n  Priority\n  "),_c('vue-form-generator',{attrs:{"schema":_vm.schemaSkipBlacklist,"model":_vm.skipBlacklist},on:{"model-updated":function($event){return _vm.changeSwitch()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }